import {Component, Input, OnDestroy} from '@angular/core';
import {Store} from '@ngxs/store';
import {NgbActiveModal} from '@ng-bootstrap/ng-bootstrap';
import {PreorderMessageHistory, PreorderModel} from '../../../services/preorder/preorder.model';
import {GetPreorderDetail} from '../../../../state/actions/appState.preorders.actions';
import {OpenModalPaymentDetail} from '../../../../state/actions/appState.modals.actions';
import {PreorderPositionModel} from '../../../services/preorder/preorderPosition.model';

export interface PreorderProductsSummaryProduct {
  id: string;
  articleId: string;
  description: string;
  count: number;
  priceSingle: number;
  priceTotal: number;
}

export interface PreorderProductsSummary {
  amount: number;
  currency: string;
  products: PreorderProductsSummaryProduct[];
}

@Component({
  selector: 'app-paycard-detail',
  templateUrl: './preorder-detail-modal.component.html',
  styleUrls: ['./preorder-detail-modal.component.scss']
})
export class PreorderDetailModalComponent implements OnDestroy {
  @Input() set preorder(p: PreorderModel) {
    this.preorders = p;
    this.preorderProducts = this.mapPreorder(p);
    this.messages = this.convertMessages(p.messageHistory);
  }

  preorders: PreorderModel;
  preorderProducts: PreorderProductsSummary = null;
  showMessages = false;
  messages: { date: Date, message: string }[] = null;

  constructor(
    private store: Store,
    private activeModal: NgbActiveModal
  ) {
  }

  ngOnDestroy(): void {
    this.store.dispatch(new GetPreorderDetail(null));
  }

  onCloseModal() {
    this.activeModal.dismiss();
  }

  onShowPayment() {
    this.store.dispatch(new OpenModalPaymentDetail(this.preorders.payment));
  }

  toggleMessages() {
    this.showMessages = !this.showMessages;
  }

  private mapPreorder(preorder: PreorderModel): PreorderProductsSummary {
    debugger
    if (!preorder || !preorder.products) {
      return null;
    }

    const products = preorder.products.reduce((sum, element) => sum.concat(this.mapPosition(element)), []);
    debugger;
    return {
      products,
      currency: preorder.payment && preorder.payment.currency ? preorder.payment.currency : '€',
      amount: products.reduce((sum, element) => {
        return sum += element.priceTotal;
      }, 0)
    };
  }

  private mapPosition(p: PreorderPositionModel): PreorderProductsSummaryProduct[] {
    let positions: PreorderProductsSummaryProduct[] = [];
    positions = positions.concat({
      articleId: p.articleId,
      count: p.count,
      description: p.description,
      id: p.id,
      priceSingle: p.price,
      priceTotal: p.price * p.count
    });
    if (p.depositPosition) {
      positions = positions.concat(this.mapPosition(p.depositPosition));
    }
    return positions;
  }

  private convertMessages(history: PreorderMessageHistory): { date: Date, message: string }[] {
    let result: { date: Date, message: string }[] = null;
    if (history) {
      result = [];
      const keys = Object.keys(history);
      result = keys.map(timestamp => {
        const date = new Date(+timestamp);
        const message = history[timestamp];
        try {
          return { date, message: JSON.parse(message) };
        } catch (e) {
          console.log(e);
          return { date, message };
        }
      });
      result.sort(((a, b) => b.date.getTime() - a.date.getTime()));
    }
    return result;
  }
}
